import React, { useMemo } from 'react'
import { TabSwitch } from 'components'
import constants from 'helpers/constants'

const statuses = [
  'subscription-failed',
  'subscription-cancelled',
  'pending',
  'database-pending',
  'database-approved',
  'user-declined',
  'maybe',
  'no',
  'pre-approved',
  'yes',
]
const { WAITLIST_STATUS_CONFIG } = constants

const StatusFilter = ({ onFilter, status: currentStatus }) => {
  const filters = useMemo(
    () =>
      statuses.map(status => ({
        label: WAITLIST_STATUS_CONFIG[status].state.toUpperCase(),
        key: status,
        isActive: status === currentStatus,
        width: WAITLIST_STATUS_CONFIG[status].width,
      })),
    [currentStatus]
  )
  return (
    <div className="absolute flex top-10 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 md:-top-12">
      <TabSwitch buttonClassName="w-40" tabs={filters} onChange={filter => onFilter(filter.key)} />
    </div>
  )
}

export default StatusFilter
